import React from 'react';
import { useRouter } from 'next/router';
import styled from '@emotion/styled';
import { useTheme } from '@mui/material/styles';
import { KitCard, KitCardBody } from 'components/common/cms-kit';
import hex2rgba from 'services/colorUtils/hex2rgba';
import { buttonColor } from 'services/styleUtils/buttonStyleUtils';
import { headingColor } from 'services/styleUtils/headingStyleUtils';

const ProductOfferingsModuleCard = (props) => {
  const { module, cardHeaderColor, cardHeaderTabColor, cardHeaderTextColor } =
    props;

  const router = useRouter();
  const theme = useTheme();

  const StateDashed = styled.div`
    border-top: 1px dashed #000;
    margin: 0;
    padding-top: 0;
  `;

  const StateContainer = styled.div`
    width: 75%;
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: center;
    margin: 5px 15px 15px 15px;
    padding-top: 10px;
    cursor: pointer;
  `;

  const StateIcon = styled.div`
    display: inline-block;
    margin: 0 5px 0 0;
  `;

  const StateText = styled.div`
    display: inline-block;
    font-size: 0.813rem;
  `;

  const CardHeaderContainer = styled.div`
    margin: 0 0 5px 0;
    background-color: ${hex2rgba(
      headingColor(theme, props?.cardHeaderColor),
      0.1,
    )};
    padding: 0 10px 0 20px;
    height: 70px;
    position: relative;
    display: flex;
    justify-content: flex-start;
    align-items: center;
  `;

  const OfferingName = styled.div`
    color: ${buttonColor(theme, props?.cardHeaderTextColor)};
    background-color: transparent;
    font-size: 1.063rem;
    line-height: 1.313rem;
    font-weight: 600;
    position: relative;
    z-index: 100;
  `;

  const DecorativeTab = styled.div`
    display: inline-block;
    background-color: ${buttonColor(theme, props?.cardHeaderTabColor)};
    position: absolute;
    left: -10px;
    height: 45px;
    width: 10px;
    border-radius: 6px 0 0 6px;
  `;

  return (
    <KitCard style={{ width: '21rem' }} key={module?.key}>
      <React.Fragment>
        <KitCardBody style={{ padding: 0 }}>
          <CardHeaderContainer>
            <DecorativeTab></DecorativeTab>
            <OfferingName>{props.offering?.fields?.moduleName}</OfferingName>
          </CardHeaderContainer>
          <CardBodyContainer>
            {props?.offering?.fields?.seriesDescription}
          </CardBodyContainer>
        </KitCardBody>
      </React.Fragment>
    </KitCard>
  );
};

export default ProductOfferingsModuleCard;

const ImageContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '104px',
  backgroundSize: '100%',
  backgroundPosition: 'right 30% top 35%',
  backgroundRepeat: 'no-repeat',
}));

const CardBodyContainer = styled('div')(({ theme }) => ({
  padding: '10px',
  minHeight: '50px',
}));
